/** Shell types for multi-shell routing architecture. */

/** Available shell identifiers. */
export type ShellId = "admin" | "ops" | "client";

/** Shell access flags from the bootstrap endpoint. */
export interface ShellAccess {
  global: boolean;
  ops: boolean;
  client: boolean;
  field: boolean;
}

/** Shell metadata for UI display and routing. */
export interface ShellMeta {
  id: ShellId;
  label: string;
  description: string;
  basePath: string;
}

/** Shell context exposed via useShell(). */
export interface ShellState {
  /** Currently active shell. */
  activeShell: ShellId;
  /** Shells the user has access to. */
  shellAccess: ShellAccess;
  /** List of shells the user can switch to. */
  availableShells: ShellId[];
  /** Switch to a different shell. */
  setActiveShell: (shell: ShellId) => void;
  /** Whether the shell has been resolved from session data. */
  isResolved: boolean;
}

/** Shell metadata registry. */
export const SHELL_META: Record<ShellId, ShellMeta> = {
  admin: {
    id: "admin",
    label: "Command",
    description: "Platform governance",
    basePath: "/admin",
  },
  ops: {
    id: "ops",
    label: "Frontier",
    description: "Projects and deployments",
    basePath: "/ops",
  },
  client: {
    id: "client",
    label: "Kodiak",
    description: "Client portal",
    basePath: "/client",
  },
};
